import { get } from 'lodash-es';
import { SCHEMA_URL } from 'site-modules/shared/pages/seo';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';

export function getPhoneNumber(phoneNumberObj) {
  const { areaCode, prefix, postfix } = phoneNumberObj;
  return areaCode && prefix && postfix ? `${areaCode}-${prefix}-${postfix}` : '';
}
export function getOfferSchema({ vehicle, urlCity = '', urlStateName = '', urlPattern = '' }) {
  const { make, model, year } = get(vehicle, 'vehicleInfo.styleInfo', {});
  const { city, stateName, stateCode, zip, street } = get(vehicle, 'dealerInfo.address', {});
  const { name: dealerName, distance } = get(vehicle, 'dealerInfo', {});
  const cityStateNameDescPart = city && stateName ? ` in ${city}, ${stateName}` : '';
  const type = get(vehicle, 'type', '');
  const itemCondition = isUsed(type) ? `${SCHEMA_URL}/UsedCondition` : `${SCHEMA_URL}/NewCondition`;
  const isCityStateUrl = urlPattern.includes('city-state');

  const price = get(vehicle, 'prices.advertisedPrice', get(vehicle, 'prices.displayPrice', 0));

  const schema = {
    '@type': 'Offer',
    availability: `${SCHEMA_URL}/InStock`,
    price,
    priceCurrency: 'USD',
    description: `This ${year} ${make} ${model} is in stock and for sale${cityStateNameDescPart}. View photos and learn more about this ${year} ${model} on Edmunds.`,
    itemCondition,
  };
  if (isCityStateUrl) {
    const trackablePhoneNumber = getPhoneNumber(get(vehicle, 'dealerInfo.phoneNumbers.trackable', {}));
    const basicPhoneNumber = getPhoneNumber(get(vehicle, 'dealerInfo.phoneNumbers.basic', {}));
    const isSameCityOrCloseDistance =
      (urlCity && urlCity === city && urlStateName && urlStateName === stateName) || distance <= 25;
    schema.seller = {
      '@type': 'AutoDealer',
      name: dealerName,
      telephone: trackablePhoneNumber || basicPhoneNumber,
    };
    if (isSameCityOrCloseDistance) {
      schema.seller.address = {
        '@type': 'PostalAddress',
        addressLocality: city,
        addressRegion: stateCode,
        postalCode: zip,
        streetAddress: street,
      };
    }
  }
  return schema;
}

export function getAggregateOfferSchema({ searchResults }) {
  const inventories = get(searchResults, 'inventories.results', []);

  const highPrice = inventories.reduce((highestPrice, vin) => {
    const vinPrice = get(vin, 'prices.advertisedPrice', get(vin, 'prices.displayPrice', 0));
    return vinPrice && (!highestPrice || vinPrice > highestPrice) ? vinPrice : highestPrice;
  }, undefined);
  const lowPrice = inventories.reduce((lowestPrice, vin) => {
    const vinPrice = get(vin, 'prices.advertisedPrice', get(vin, 'prices.displayPrice', 0));
    return vinPrice && (!lowestPrice || vinPrice < lowestPrice) ? vinPrice : lowestPrice;
  }, undefined);

  return lowPrice
    ? {
        '@type': 'AggregateOffer',
        lowPrice,
        highPrice,
        offerCount: get(searchResults, 'inventories.totalNumber'),
        priceCurrency: 'USD',
      }
    : null;
}
